import * as Constants from "../common/Constants";


export const actionCreators = {
    showNotification: (options = {}) => (dispatch, getState) => {
       
        dispatch({ type: Constants.SHOW_NOTIFICATION, payload: options });
    },

    hideNotification: (id) => (dispatch, getState) => {
        dispatch({ type: Constants.HIDE_NOTIFICATION, id: id });
    },
    
    removeNotification: (id) => (dispatch, getState) => {
        dispatch({ type: Constants.REMOVE_NOTIFICATION, id: id });
    }
};


// WEBPACK FOOTER //
// ./src/actions/NotificationActions.js